import { connect } from "react-redux";
import AppDownload from "./AppDownload";
import { getDefaultStoreUrl } from "../../state/modules/regionalStore";

const mapStateToProps = state => ({
  defaultStoreUrl: getDefaultStoreUrl(state)
});

export default connect(mapStateToProps)(AppDownload);
